// extracted by mini-css-extract-plugin
module.exports = {"headline":"Headline-module--headline--2SmMj","noMargin":"Headline-module--noMargin--301lz","light":"Headline-module--light--1Rm2g","noColor":"Headline-module--noColor--BadFY"};